<template>
  <div class="pre-copyright-navigation">
    <h2>Pre-Copyright Navigation</h2>
    <p>
      Add or remove Pre-Copyright links. Edit label and URL for individual links
      in the Pre-Copyright section.
    </p>
    <SinglePreCopyrightItem
      v-for="(el, idx) in itemsArr"
      :key="idx"
      :index="idx"
      :el="el"
      :isLast="isLast(idx)"
      @addNewItem="handleAddNewItem"
      @removeItem="handleRemoveItem"
      @pushDownItem="handlePushDownItem"
      @pushUpItem="handlePushUpItem"
      @termsValue="handleTermsValue"
      @domainValue="handleDomainValue"
      class="single-item"
    />
  </div>
</template>

<script>
import SinglePreCopyrightItem from "./SinglePreCopyrightItem.vue";
export default {
  props: {
    navData: {
      type: Object,
    },
  },
  components: {
    SinglePreCopyrightItem,
  },
  // mounted() {
  //   console.log(this.navData.value);
  //   this.itemsArr = [];
  //   this.navData.value.forEach((element) => {
  //     this.itemsArr.push({
  //       domain: element.url,
  //       terms: element.label,
  //     });
  //   });
  // },
  watch: {
    navData: {
      deep: true,
      handler() {
        this.itemsArr = [];
        this.navData.value.forEach((element) => {
          this.itemsArr.push({
            domain: element.url,
            terms: element.label,
          });
        });
      },
    }
  },
  data() {
    return {
      itemsArr: [
        {
          terms: "",
          domain: "",
        },
      ],
    };
  },
  methods: {
    handleAddNewItem() {
      this.itemsArr.push({
        terms: "",
        domain: "",
      });
      this.$emit("preCopyright", this.itemsArr);
    },
    handleRemoveItem(index) {
      this.itemsArr.splice(index, 1);
      this.$emit("preCopyright", this.itemsArr)
    },
    handlePushDownItem(index) {
      if (index + 1 == this.itemsArr.length - 1) return;
      let item = this.itemsArr.splice(index, 1);
      this.itemsArr.splice(index + 1, 0, item[0]);
      this.$emit("preCopyright", this.itemsArr)
    },
    handlePushUpItem(index) {
      console.log(index, this.itemsArr.length);
      if (index == this.itemsArr.length - 1) return;
      let item = this.itemsArr.splice(index, 1);
      this.itemsArr.splice(index - 1, 0, item[0]);
      this.$emit("preCopyright", this.itemsArr)
    },
    handleTermsValue(obj) {
      this.itemsArr[obj.id].terms = obj.terms;
      this.$emit("preCopyright", this.itemsArr)
    },
    handleDomainValue(obj) {
      this.itemsArr[obj.id].domain = obj.domain;
      this.$emit("preCopyright", this.itemsArr)
    },
    isLast(index) {
      return index === this.itemsArr.length - 1;
    },
  },
};
</script>

<style scoped lang='scss'>
.pre-copyright-navigation {
  h2 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #001529;
    padding: 25px 0;
    border-bottom: 1px solid #cbcbe4;
  }
  p {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #001529;
    margin: 32px 0 24px 0;
  }
}
</style>